import { useWalletsMe } from '@/api/wallets';
import { ErrorCard } from '@starsoft/common/components';
import SkeletonNoEmptyWalletModalContent from '../Skeleton';
import EmptyWalletModalContent from '../../Empty/Content';
import NoEmptyWalletModalContent from './Content';

export default function WalletContent() {
  const { wallet, refetch, error: walletError, isLoading } = useWalletsMe();

  if (walletError) {
    return <ErrorCard error={walletError} refetch={refetch} />;
  }

  if (isLoading) {
    return <SkeletonNoEmptyWalletModalContent />;
  }

  return wallet?.isEmpty ? (
    <EmptyWalletModalContent />
  ) : (
    <NoEmptyWalletModalContent />
  );
}
